import translateMessage from './translateMessage';

export function isSafeGetRetry(error) {
  if (!error || !error.kind) return true;
  if (error.message === 'DATA_INPUT_BUSY') return true;
  return ['network', 'timeout', 'server', 'serviceUnavailable'].includes(error.kind);
}

const rootField = field => (
  !field || ['request', 'root', '__root__'].includes(String(field).toLowerCase())
);

export function applyApiFieldErrors(error, setFieldError, _t, options = {}) {
  const fieldErrors = Array.isArray(error?.fieldErrors) ? error.fieldErrors : [];
  fieldErrors.forEach((item) => {
    const mappedField = rootField(item?.field)
      ? 'root.server'
      : (options.mapField ? options.mapField(item.field, item) : item.field);
    const field = mappedField || 'root.server';
    setFieldError(field, {
      type: 'server',
      message: translateMessage(item?.message, error?.status || 400, item?.params),
    });
  });
  return fieldErrors.length > 0;
}
